'use strict';

import { validator } from '..';

const $lang = document.documentElement.lang == 'es' ? 'es' : 'pt';

const messages = {
  completeName: {
    pt: 'Digite seu nome completo.',
    es: 'Introduce tu nombre completo.',
  },
  requiredField: {
    pt: 'Campo obrigatório.',
    es: 'Campo obligatorio.',
  },
  invalidDocument: {
    pt: 'CPF inválido.',
    es: 'DNI inválido.',
  },
};

export const lightningOneValidate = () => {
  const fieldsRules = {
    rules: {
      name: {
        required: true,
        minlength: 5,
      },
      corporate_email: {
        required: true,
        email: true,
      },
      cpf: {
        required: true,
        minlength: function () {
          if (document.documentElement.lang === 'pt-BR') {
            return 14;
          } else {
            return false;
          }
        },
      },
      phone: {
        required: true,
      },
      company_id: {
        required: true,
        notOnlyZero: '0',
      },
      unity_id: {
        required: true,
        notOnlyZero: '0',
      },
      video: {
        required: true,
      },
      use_terms: {
        required: true,
      },
      volunteer_work_terms: {
        required: true,
      },
    },
    messages: {
      name: {
        required: messages.requiredField[$lang],
        minlength: messages.completeName[$lang],
      },
      corporate_email: {
        required: messages.requiredField[$lang],
        email: 'Email inválido.',
      },
      cpf: {
        required: messages.requiredField[$lang],
        minlength: messages.invalidDocument[$lang],
      },
      phone: {
        required: messages.requiredField[$lang],
      },
      company_id: {
        required: messages.requiredField[$lang],
      },
      unity_id: {
        required: messages.requiredField[$lang],
      },
      video: {
        required: messages.requiredField[$lang],
      },
      use_terms: {
        required: messages.requiredField[$lang],
      },
      volunteer_work_terms: {
        required: messages.requiredField[$lang],
      },
    },
  };

  validator('.js-validate', fieldsRules);
};
